import { getUUID } from "../utils/monitoring";
import { findOutEnvByEnvName } from "@gcloud-npm/utils.enums.environment";
import { PROCESS_NAME } from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";
import calculateHeaderParams from "@gcloud-npm/node.build-process.build-environments";
import Request from "../utils/request";
import Sonda from "../utils/sonda";
import { MethodType } from "../utils/types";


const FAMILY_API = 'geo';
const PATH = "/api/movistar-layer/address/v1/coverage/horizontal-search";
const EVENT_NAME = "ADDRESS.HORIZONTAL_SEARCH";

export const searchHorizontalAddresses = ({
  params,
  context,
  idFront = "VT",
  envName = `${process.env.NEXT_PUBLIC_ENV_NAME}`,
  build = false,
}) => {
  const { userType } = context;
  const myContext = {
    ...context,
    environment: findOutEnvByEnvName(envName),
  };
  const { [FAMILY_API]: connectionData } = myContext.environment;
  const { endpoint: host } = connectionData;
  const { address, orderPC } = params;

  let URL_API = `${host}${PATH}?address=${address}`;
  
  if(orderPC) {
    URL_API = `${URL_API}&orderPC=${orderPC}`;
  }
  const idRequest = getUUID(idFront);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: userType ? PROCESS_NAME.CLIENT : PROCESS_NAME.OPEN,
  });

  const headers2Use = calculateHeaderParams(build, FAMILY_API, context);

  const request = new Request({
    method: MethodType.GET,
    endpoint: URL_API,
    headers: { ...headers2Use },
    sonda,
  });
  return request.makeRequest();
};